import * as React from 'react';
export default function isMuiElement(element, muiNames) {
  return (
    /*#__PURE__*/
    React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1
  );
}